import * as React from 'react'

import { WithBloomreachConfig, withErrorPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../../cms'
import { defaultErrorProps } from '../error-props'
import { withCart } from './with-cart'

export function composePDP<T>(PDP: React.FunctionComponent<T>, config?: WithBloomreachConfig) {
  return compose<T, T>(
    withCms(config),
    withErrorPage(defaultErrorProps),
    withLayout(),
    withCart({ isReadOnly: true })
  )(PDP)
}
